module.exports = __webpack_public_path__ + "static/media/20-WaterHeatExchanger - DX cool - No heat.a9158a8e.png";